<template>
  <div>
    <Modal title="Tem certeza que deseja cancelar?" :width="500" v-show="showModal('cancelSignature')">
      <Confirmation :isModal="false" title="Você tem certeza?" type="danger" :confirmed="cancel" />
    </Modal>
  </div>
</template>

<script>
import Confirmation from "@nixweb/nixloc-ui/src/component/shared/Confirmation.vue";
import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";

import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "CancelSignature",
  components: {
    Confirmation,
    Modal,
  },
  data() {
    return {
      id: "",
    };
  },
  computed: {
    ...mapGetters("generic", ["showModal", "event"]),
  },
  methods: {
    ...mapMutations("generic", ["openModal", "hideModal", "removeLoading", "addEvent"]),
    ...mapActions("generic", ["deleteApi"]),
    cancel() {
      let params = {
        url: `/api/v1/signature/delete?id=${this.id}`,
        obj: {},
      };
      this.deleteApi(params).then((response) => {
        if (response.success) {
          this.hideModal("cancelSignature");
          this.addEvent({ name: "getAllListViewWithDataHandler" });
        }
        this.removeLoading(["confirm"]);
      });
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "cancelSignature") {
          this.id = event.data.id;
          this.openModal("cancelSignature");
        }
      },
      deep: true,
    },
  },
};
</script>
